'use strict';

var svaneTvis = svaneTvis || {};

svaneTvis.form = svaneTvis.form || new function () {
    this.init = function () {
        let inputs = document.querySelectorAll('.select-store-input');
        let shops = document.querySelectorAll('#ShopList option');
        let shopList = document.querySelector('#ShopList');
        
        if(shopList != null && shops.length){
            var shopEmail = document.querySelector('#ShopEmail');
            var shopSecondrayEmail = document.querySelector('#ShopEmailCC');

            // Add eventlistener on radio buttons
            for (let i = 0; i < inputs.length; i++) {
                const input = inputs[i];
                
                input.addEventListener('change', function () {
                    let inputIndex = i + 1;
                    
                    let shop = shops[inputIndex].getAttribute('value');
                    shopList.value = shop;

                    let selectedStore = document.querySelector('.selected-store');
                    let selectedStoreName = document.querySelector('.selected-store-name');

                    selectedStore.style.display = "block";
                    selectedStoreName.innerHTML = shop;

                    // Set ShopEmail and ShopEmailCC when radiobutons changes
                    var preselected = shopList.options[shopList.selectedIndex];

                    shopEmail.setAttribute("value", preselected.getAttribute('data-email'));
                    shopSecondrayEmail.setAttribute("value", preselected.getAttribute('data-emailcc'));

                }, false);
            }
            
            // Set ShopEmail and ShopEmailCC when ShopList-select changes
            shopList.addEventListener('change', function (e) {
                var selected = shopList.options[shopList.selectedIndex];
                
                shopEmail.setAttribute("value", selected.getAttribute('data-email'));
                shopSecondrayEmail.setAttribute("value", selected.getAttribute('data-emailcc'));
            });
        }

        // var getCookie = function (name) {
        //     var value = "; " + document.cookie;
        //     var parts = value.split("; " + name + "=");
            
        //     if (parts.length == 2) {
        //         return parts.pop().split(";").shift();
        //     } 
        // };

        // Populate the selected store on reload, if already selected
        // window.addEventListener('DOMContentLoaded', (event) => {
        //     var currentShop = getCookie('SelectedShop');
        //     if(currentShop){
        //         var currentInput = document.querySelector('.select-store-input[data-shop-id="' + currentShop + '"]');
                
        //         if(currentInput) {
        //             currentInput.checked = false;
        //             currentInput.click();
        //         }
        //     }
        // });
        

    };
}();
